import React from 'react';
import './PassiveButton.css';

interface PassiveButtonProps {
  passiveImage: string;
}

const PassiveButton: React.FC<PassiveButtonProps> = ({ passiveImage }) => {
  return (
    <div className="passive-ability-btn">
      <img className="passive-ability-img" src={passiveImage} alt="Passive Ability" />
      <div className="passive-ability-letter">P</div>
    </div>
  );
};

export default PassiveButton;
